<h3 mat-dialog-title>{{data.title}}</h3>

<mat-dialog-content>
    <form [formGroup]="gameRecordWebTSNForm" class="mb-2" >
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.gameRecordForm.Web_TSN_Object_Key' | translate}}</mat-label>
            <textarea formControlName="webTSNobject" matInput type="text"></textarea>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="onCancle()" class="second-btn" [hidden]="!data.cancleCallback">{{'gen_dialog_btn_cancle' | translate}}</button>
    <button mat-button [disabled]="gameRecordWebTSNForm.invalid" cdkFocusInitial class="first-btn" (click)="onConfirm()">{{'FORM.BTN_SAVE' | translate}}</button>
</mat-dialog-actions>